// Funciones para manejar el token
export const setToken = (token) => {
  console.log('💾 [SessionManager] Guardando token:', token ? '***' : 'null');
  localStorage.setItem('token', token);
  console.log('✅ [SessionManager] Token guardado');
};

export const getToken = () => {
  const token = localStorage.getItem('token');
  console.log('🔍 [SessionManager] Obteniendo token:', token ? '***' : 'null');
  return token;
};

// Funciones para manejar los datos del usuario
export const setUserData = (userData) => {
  console.log('💾 [SessionManager] Guardando datos de usuario:', userData);
  localStorage.setItem('usuario', JSON.stringify(userData));
  console.log('✅ [SessionManager] Datos de usuario guardados');
};

export const getUserData = () => {
  const userData = localStorage.getItem('usuario');
  console.log('🔍 [SessionManager] Obteniendo datos de usuario:', userData);
  return userData ? JSON.parse(userData) : null;
};

// Función para limpiar la sesión
export const clearSession = () => {
  console.log('🗑️ [SessionManager] Limpiando sesión...');
  localStorage.removeItem('token');
  localStorage.removeItem('usuario');
  console.log('✅ [SessionManager] Sesión limpiada');
};

// Función para verificar si el usuario está autenticado
export const isAuthenticated = () => {
  const isAuth = !!getToken();
  console.log('🔐 [SessionManager] Verificando autenticación:', isAuth);
  return isAuth;
}; 